import { PageHeader, TabBar } from '@ksyos/design-system';
import { useState } from 'react';
import { ManagerAuthorization } from '@common/enums';
import { Departments } from '@common/enums/departments';
import { PageTemplate } from '@frontend/components/templates/PageTemplate';
import { translateKey } from '@frontend/translate';
import { assertHasAuthorization } from '@frontend/utils';
import { ManagerRolesAuthorizationDetails } from './ManagerRolesAuthorizationsDetails';

export function ManagerRolesAuthorizations() {
    const [selectedDepartment, setSelectedDepartment] = useState<Departments>(Object.values(Departments)[0]);
    assertHasAuthorization(ManagerAuthorization.managerAuthorizations);

    return (
        <PageTemplate>
            <PageHeader title={translateKey('common.managerAuthorizations')} />
            <TabBar sx={{ mb: 8 }}>
                {Object.values(Departments).map((department) => (
                    <TabBar.Button
                        isSelected={selectedDepartment === department}
                        key={department}
                        onClick={() => onClick(department)}
                    >
                        {department}
                    </TabBar.Button>
                ))}
            </TabBar>
            <ManagerRolesAuthorizationDetails department={selectedDepartment} />
        </PageTemplate>
    );

    function onClick(department: Departments) {
        setSelectedDepartment(department);
    }
}
